import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const ProductCard = ({ product, index = 0 }) => {
  const [back, setBack] = useState(false);
  const lowStock = product.low_stock_sizes?.length > 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`}
        onMouseEnter={() => setBack(true)} onMouseLeave={() => setBack(false)}
        className="group block">
        <div className="relative aspect-[4/5] overflow-hidden bg-charcoal">
          <img src={product.front_image} alt={product.name}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${back ? "opacity-0" : "opacity-100"}`} />
          <img src={product.back_image} alt={`${product.name} back`}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${back ? "opacity-100" : "opacity-0"}`} />
          <div className="absolute top-3 left-3 flex gap-2">
            {product.preorder && (
              <span className="bg-bg/90 font-mono text-[9px] uppercase tracking-[0.2em] px-2 py-1" data-testid={`badge-preorder-${product.id}`}>Pre-order</span>
            )}
            {lowStock && (
              <span className="bg-cs-red text-cream font-mono text-[9px] uppercase tracking-[0.2em] px-2 py-1" data-testid={`badge-lowstock-${product.id}`}>Low stock</span>
            )}
          </div>
          <button
            onClick={(e) => { e.preventDefault(); setBack(!back); }}
            className="absolute bottom-3 right-3 bg-bg/80 backdrop-blur-sm font-mono text-[9px] uppercase tracking-[0.2em] px-3 py-1.5 lg:opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            data-testid={`flip-${product.id}`}>
            {back ? "Front" : "Back"}
          </button>
        </div>
        <div className="flex justify-between items-baseline mt-4">
          <div>
            <h3 className="font-display font-semibold text-lg leading-tight">{product.name}</h3>
            <p className="text-graytx text-sm mt-0.5">{product.tagline}</p>
          </div>
          <span className="font-mono text-sm">${product.price.toFixed(0)}</span>
        </div>
      </Link>
    </motion.div>
  );
};
